var chunkMapping = {
	"678": [
		80678
	],
	"759": [
		80759
	],
	"1099": [
		11099
	],
	"1180": [
		31180
	],
	"1209": [
		11209
	],
	"1364": [
		31364
	],
	"1464": [
		1464
	],
	"1525": [
		31525
	],
	"1574": [
		41574
	],
	"1664": [
		1664
	],
	"1961": [
		11961
	],
	"2326": [
		22326
	],
	"2743": [
		82743
	],
	"2911": [
		32911
	],
	"3559": [
		3559
	],
	"3729": [
		23729
	],
	"4241": [
		74241
	],
	"5147": [
		95147
	],
	"5783": [
		45783
	],
	"5965": [
		45965
	],
	"6178": [
		2585,
		4004,
		11573,
		23558,
		30675,
		52429,
		54715,
		65309,
		67059,
		72934,
		97011
	],
	"6711": [
		6711
	],
	"7283": [
		67283
	],
	"7740": [
		17740
	],
	"8596": [
		38596
	],
	"9117": [
		9117
	],
	"9281": [
		79281
	],
	"9282": [
		99282
	],
	"9566": [
		19566
	],
	"9675": [
		69675
	],
	"9803": [
		69803
	],
	"9853": [
		79853
	]
};
var idToExternalAndNameMapping = {
	"1464": [
		"default",
		"./IosSwitch",
		38795
	],
	"1664": [
		"default",
		"./ImagesCarousel",
		38795
	],
	"2585": [
		"default",
		"./Checkbox",
		38795
	],
	"3559": [
		"default",
		"./ModalConfirmWithType",
		38795
	],
	"4004": [
		"default",
		"./Toast",
		38795
	],
	"6711": [
		"default",
		"./I18nService",
		38795
	],
	"9117": [
		"default",
		"./DefaultSearchBar",
		38795
	],
	"11099": [
		"default",
		"./DatePickerField",
		38795
	],
	"11209": [
		"default",
		"./SpinningLoader",
		38795
	],
	"11573": [
		"default",
		"./ButtonDropdown",
		38795
	],
	"11961": [
		"default",
		"./PageDescription",
		38795
	],
	"17740": [
		"default",
		"./DefaultTextbox",
		38795
	],
	"19566": [
		"default",
		"./Space",
		38795
	],
	"22326": [
		"default",
		"./SearchBar",
		38795
	],
	"23558": [
		"default",
		"./Alert",
		38795
	],
	"23729": [
		"default",
		"./Dashboard",
		80773
	],
	"30675": [
		"default",
		"./Steps",
		38795
	],
	"31180": [
		"default",
		"./FormAttributeItem",
		38795
	],
	"31364": [
		"default",
		"./KepabMenu",
		38795
	],
	"31525": [
		"default",
		"./FooterActions",
		38795
	],
	"32911": [
		"default",
		"./StatusTags",
		38795
	],
	"38596": [
		"default",
		"./Tag",
		38795
	],
	"41574": [
		"default",
		"./FormAttributeGroup",
		38795
	],
	"45783": [
		"default",
		"./DateRangePickerField",
		38795
	],
	"45965": [
		"default",
		"./Pagination",
		38795
	],
	"52429": [
		"default",
		"./MultiSelectDropdown",
		38795
	],
	"54715": [
		"default",
		"./Theme",
		38795
	],
	"65309": [
		"default",
		"./EmptyState",
		38795
	],
	"67059": [
		"default",
		"./CopyToClipboard",
		38795
	],
	"67283": [
		"default",
		"./Cascader",
		38795
	],
	"69675": [
		"default",
		"./RadioGroup",
		38795
	],
	"69803": [
		"default",
		"./NavigationHorizontalBar",
		38795
	],
	"72934": [
		"default",
		"./ErrorNavigation",
		38795
	],
	"74241": [
		"default",
		"./Button",
		38795
	],
	"79281": [
		"default",
		"./PageContainer",
		38795
	],
	"79853": [
		"default",
		"./Text",
		38795
	],
	"80678": [
		"default",
		"./H5",
		38795
	],
	"80759": [
		"default",
		"./Tooltip",
		38795
	],
	"82743": [
		"default",
		"./H4",
		38795
	],
	"95147": [
		"default",
		"./SingleDropdownAndMulti",
		38795
	],
	"97011": [
		"default",
		"./TabsBar",
		38795
	],
	"99282": [
		"default",
		"./Typography",
		38795
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_modules__[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}